import { render, staticRenderFns } from "./UnidentifiedPaymentsModule.vue?vue&type=template&id=794ba9df"
import script from "./UnidentifiedPaymentsModule.vue?vue&type=script&lang=js"
export * from "./UnidentifiedPaymentsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports